import React, { useEffect, useState, useCallback, useContext } from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import DataTable from "react-data-table-component";
import { CartContext } from "../../../contexts/cartContext";
import { CurrencyContext } from "../../../contexts/currencyContext";
import { toast, ToastContainer } from "react-toastify";

const ExhibitionDetails = () => {
  const { ids } = useParams();
  const navigate = useNavigate();
  const [wishlists, setWishlists] = useState([]);
  const { wishlist, addToWishlist } = useContext(CartContext);
  const { currencyContxt } = useContext(CurrencyContext); // Use context

  const [exhibitionID, initialArtistID] = ids ? ids.split("-") : [null, null];

  const [loading, setLoading] = useState(true);
  const [artworks, setArtworks] = useState([]);
  const [mainArtistID, setMainArtistID] = useState(null);
  const [mainArtistArtworks, setMainArtistArtworks] = useState([]);
  const [otherArtistArtworks, setOtherArtistArtworks] = useState([]);

  // Fetch Exhibition Data
  const fetchExhibitionDetails = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://igapi.heuristticminds.com/api/ExhibitionList/Get-GetExhibitionLiveArtworkDetailsByExhibitionID?exhibitionID=${exhibitionID}`
      );
      const fetchedArtworks = response.data || [];
      setArtworks(fetchedArtworks);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching exhibition details:", error);
      setLoading(false);
    }
  }, [exhibitionID]);

  useEffect(() => {
    fetchExhibitionDetails();
  }, [fetchExhibitionDetails]);

  // Group artworks by artist
  const groupedArtworks = artworks.reduce((acc, item) => {
    const { artistID, artistName, imageURLArtist, imageURLArtwork, productTitle } = item;
    if (!acc[artistID]) {
      acc[artistID] = {
        artistID,
        artistName,
        imageURLArtist,
        artworks: [],
        isMainArtist: artistID === mainArtistID // Mark as main artist if artistID matches
      };
    }
    acc[artistID].artworks.push({ imageURLArtwork, productTitle });
    return acc;
  }, {});

  const artistList = Object.values(groupedArtworks);

  // Ensure mainArtistID is set properly after artworks are loaded
  useEffect(() => {
    if (artistList.length > 0) {
      const validInitialArtist = initialArtistID && artistList.some(artist => artist.artistID.toString() === initialArtistID);
      setMainArtistID(validInitialArtist ? parseInt(initialArtistID) : artistList[0]?.artistID);
    }
  }, [artworks, initialArtistID]);

  const mainArtist = artistList.find(artist => artist.artistID === mainArtistID) || artistList[0];

  // Other artists now INCLUDE the main artist
  const otherArtists = artistList.filter(artist => artist.artistID !== mainArtistID);

  // Handle Artist Swap
  const handleArtistSwap = (newArtistID) => {
    setMainArtistID(newArtistID);
  };


  const handleDetails = (id, productTitle) => {
    const formattedTitle = productTitle.replace(/ /g, '-'); // Replace spaces with '-'
    navigate(`/artwork/${formattedTitle}-${id}`, { state: { id: id } });
    window.scrollTo({
      top: 0,
      behavior: "instant"
    });
  };

  const handleArtist = (artistId, artistName) => {
    const artist = artistName.replace(/ /g, '-'); // Replace spaces with '-'
    navigate(`/artist/${artist}-${artistId}`, { state: { artistId: artistId } });
    window.scrollTo({
      top: 0,
      behavior: "instant"
    });
  };

  // Separate Main Artist & Other Artist Artworks
  useEffect(() => {
    const mainArtist = artworks.filter((artwork) => artwork.artistID === mainArtistID);
    const otherArtist = artworks.filter((artwork) => artwork.artistID !== mainArtistID);
    setMainArtistArtworks(mainArtist);
    setOtherArtistArtworks(otherArtist);
  }, [artworks, mainArtistID]);

  const columns = [
    {
      cell: (row) => {
        const isInWishlist = wishlists.some(item => item.productID === row.productID);
        return (
          <div className="pd_item" key={row.productID}>
            <div className="img_box">
              <img src={`../../../images/products/thumbnail/${row.imageURLArtwork}`} className="pd_img" alt="" />
              <a href="#" className="wishlist_link" title="WISHLIST" onClick={async (e) => {
                e.preventDefault();
                //addToWishlist(row); // Add or remove item from wishlist
                handleWishlistClick(row); // Updated function                               

              }}>
                <i className={`${isInWishlist ? 'bi bi-suit-heart-fill text-danger' : 'bi bi-suit-heart'}`}></i>
              </a>
              <span className="q_view" onClick={() => handleDetails(row.productID, row.productTitle)}>
                <i className="bi bi-eye"></i> Quick View
              </span>
              <span className="size">Size: <b>{row.size}</b></span>
            </div>
            <div className="pd_content">
              <span className="pd_brand">{row.productTitle}</span>
              <span className="pd_title">{row.category}: {row.categoryType}</span>
              <span className="pd_title">Art by:
                <span className="btn_artist1" onClick={() => handleArtist(row.artistID, row.artistName)}>
                  {row.artistName}
                </span>
              </span>
              {
                row.price_on_demand === 1 ? <><span className="btn_req" onClick={() => handleRequestPrice(row.product_id, row.productTitle)}>Request Price</span></> :

                  <div className="Price">
                    {currencyContxt.icon} {(row.price / currencyContxt.value).toFixed(2)}
                    {
                      row.discountRate === 0 ? ''
                        : <>
                          <span className="old_price">{currencyContxt.icon} {((row.gstMRP) / currencyContxt.value).toFixed(2)}</span><span className="discount">({row.discountRate}%)</span>
                        </>
                    }
                    {
                      currencyContxt.currency == "INR" ?
                        <small>Including GST</small>
                        :
                        <></>
                    }
                  </div>
              }

            </div>
          </div>
        );
      }
    },
  ];

  //Wishlist Click
  const userInfo = JSON.parse(localStorage.getItem('user-info'));
  // Fetch the wishlist data when the page loads
  const fetchWishlistData = async () => {

    if (userInfo && userInfo.buyer_id) {
      try {
        const response = await fetch(`https://igapi.heuristticminds.com/api/WishList/Get-GetWishListByUserID?user_id=${userInfo.buyer_id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const wishlistData = await response.json();

        if (wishlistData && Array.isArray(wishlistData)) {
          setWishlists(wishlistData); // Store complete wishlist items from API
        } else {
          setWishlists([]); // Set an empty wishlist if no data is returned
        }

      } catch (error) {
        console.error('Error fetching wishlist:', error);
      }
    } else {
      const localWishlist = getWishlistFromLocalStorage();
      setWishlists(localWishlist); // Store complete wishlist items from local storage
    }
  };

  // Handler for Wishlist Button Click
  const handleWishlistClick = async (item) => {

    const itemIsInWishlist = isInWishlist(item.product_id);

    if (userInfo && userInfo.buyer_id) {

      try {
        const payload = {
          customer_id: userInfo.buyer_id,
          product_id: item.product_id,
        };
        const response = await fetch("https://igapi.heuristticminds.com/api/WishList/Add-SaveWishList", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error(`Failed to update wishlist: ${response.statusText}`);
        }

        // Extract JSON data from the response
        const { action } = await response.json(); // Destructuring to get action flag


        // Display success message based on the action performed
        if (action === "Add") {
          toast.success("Artwork Added to Wishlist !!");
        } else if (action === "Remove") {
          toast.error("Artwork Removed from Wishlist !!");
        }
        // Fetch the updated wishlist after modification
        await fetchWishlistData();  // Refresh state with the updated wishlist from the database
      } catch (error) {
        console.error("Error syncing wishlist item:", item.product_id, error);
      }
    }
    else {
      if (itemIsInWishlist) {
        // Remove from wishlist logic
        removeFromWishlist(item.product_id);
        toast.error("Artwork Removed from Wishlist 2 !!");
      } else {
        addToWishlist(item);
        toast.success("Artwork Added to Wishlist !!");
      }
    }


    handleWishlistUpdate(); // Refresh wishlist state after adding/removing
  };

  // Helper function to get wishlist from localStorage
  const getWishlistFromLocalStorage = () => {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
  };

  // Context or state management function
  const handleWishlistUpdate = () => {

    if (userInfo && userInfo.buyer_id) {
      fetchWishlistData(); // Fetch from API
    } else {
      const updatedWishlist = getWishlistFromLocalStorage(); // Fetch from local storage
      setWishlists(updatedWishlist); // Update state
    }
  };
  const isInWishlist = (productId) => {
    return wishlists.some(item => item.product_id === productId);
  };

  // Function to remove item from the wishlist
  const removeFromWishlist = (productId) => {
    const updatedWishlist = wishlists.filter(item => item.product_id !== productId);
    setWishlists(updatedWishlist); // Update state
    localStorage.setItem('wishlist', JSON.stringify(updatedWishlist)); // Update local storage
  };

  useEffect(() => {
    const loadWishlist = async () => {
      await fetchWishlistData();
    };
    loadWishlist();
  }, []);
  useEffect(() => {
    setWishlists(wishlist);
  }, [wishlist]); // This will trigger every time the wishlist state changes


  //WishList Click ends
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedPd, setSelectedPd] = useState(null);

  const handleRequestPrice = (id, pdTitle) => {
    setModalOpen(true);
    setSelectedId(id);
    setSelectedPd(pdTitle);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedId(null);
    setSelectedPd(null);
  };


  return (
    <>
      <Header />
      <div style={{ marginTop: "150px" }}>
        <div className="container">
          <div className="row">
            {/* Main Artist Section */}
            <div className="col-md-4 text-center">
              <div className="framepic">
                <img src={`../../../images/artist/thumbnail/${mainArtist?.imageURLArtist}`} alt={mainArtist?.artistName} />
                <Link className="read-more" to="javascript:void(0)"  onClick={() => handleArtist( mainArtistID, mainArtist?.artistName)}>About</Link>
              </div>
              <h4 className="h2 text-center">{mainArtist?.artistName}</h4>
              <p className="h5 text-center mb-5">
                <b>{mainArtist?.artworks.length}</b> {mainArtist?.artworks.length > 1 ? "artworks in this Exhibition" : "artwork in the Exhibition"}
              </p>
            </div>
            <div className="col-md-8">


              {/* Other Artists Section */}
              
              <div className="artistgrid">
                {otherArtists.map((artist) => (
                  <div key={artist.artistID} className={`artistgimg ${artist.artistID === mainArtistID ? "active" : ""}`} onClick={() => handleArtistSwap(artist.artistID)}>
                    <img src={`../../../images/artist/thumbnail/${artist.imageURLArtist}`} alt={artist.artistName} />
                    <span className="artistgname">{artist.artistName}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Artworks of Main Artist */}
          <div>
            <h5>Artworks of {mainArtist?.artistName}</h5>
            <div className="col-md-12 pd-list">
              <DataTable
                columns={columns}
                data={mainArtistArtworks}
                noTableHead
              />
            </div>
          </div>
          {/* Artworks of Other Artists */}
          <div>
            <h5>Artworks of Other Artists</h5>
            <div className="col-md-12 pd-list">
              <DataTable
                columns={columns}
                data={otherArtistArtworks}
                noTableHead
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ExhibitionDetails;
